import React from 'react';
import CommerceDocsPage from './CommerceDocsPage';

export default function InvoicesPage() {
  return <CommerceDocsPage mode="invoice" />;
}
